export interface ArchiveSpatialStatusSummary {
	spatialWarnings: string[];
	nonSpatialWarnings: string[];
	hasSpatialFallback: boolean;
}

export function summarizeArchiveSpatialStatus(warnings: string[]): ArchiveSpatialStatusSummary {
	const spatialWarnings = warnings.filter(isArchiveSpatialWarning);

	return {
		spatialWarnings,
		nonSpatialWarnings: warnings.filter((warning) => !isArchiveSpatialWarning(warning)),
		hasSpatialFallback: spatialWarnings.length > 0,
	};
}

function isArchiveSpatialWarning(warning: string): boolean {
	return /layout anchor|layout depth|3d mode|re-estimated|rebuilt/i.test(warning);
}